<template>
    <ContainerLayout page="0">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div class="content px-1">
            <label class="mb-4">{{ $t('Please enter the account information that you want to add') }}</label>
            <Form @submit="handleRegister" :validation-schema="schema" :initial-values="initialValues" autocomplete="off">
                <div class="form-group">
                    <label style="font-weight: 600;" for="name">{{ $t('Registered User Email') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="email" type="email" class="form-control"
                        :value="currentCompany ? '' : currentUser.email" />
                    <ErrorMessage name="email" class="error-feedback" />
                </div>
                <div v-if="currentCompany" class="form-group">
                    <label style="font-weight: 600;" for="type">{{ $t('To Company') }} <sup
                            class="text-danger">*</sup></label>
                    <Field v-if="currentCompany" name="company_name" type="text" class="form-control"
                        :value="currentCompany.name" disabled />
                    <ErrorMessage name="company_name" class="error-feedback" />
                </div>
                <div v-else class="form-group">
                    <label style="font-weight: 600;" for="type">{{ $t('To Company') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="company_id" as="select" class="form-control">
                        <option value="" disabled selected>{{ $t('Select Company') }}</option>
                        <option v-for="(company, index) in companies" :key="index" :value="company.id">
                            {{ company.name }}
                        </option>
                    </Field>
                    <ErrorMessage name="company_id" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="company_position">{{ $t('User Position') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="company_position" type="text" class="form-control" />
                    <ErrorMessage name="company_position" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="company_department">{{ $t('User Unit') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="company_department" type="text" class="form-control" />
                    <ErrorMessage name="company_department" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="file">
                        {{ $t('Supporting File') }} <sup class="text-muted">{{ $t('optional') }}</sup>
                        <br>
                        <small class="text-muted">( {{ $t('.pdf / images max 5MB') }} )</small>
                    </label>
                    <Field name="file" type="file" accept="application/pdf , image/*" class="file-input"
                        @change="handleFileChange" />
                    <hr class="mt-2 mb-1">
                    <ErrorMessage name="file" class="error-feedback" />
                </div>
                <div class="form-group pt-3">
                    <button class="btn btn-main btn-block" :disabled="loading">
                        <span>{{ $t('Submit') }}</span>
                    </button>
                </div>
            </Form>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../ContainerLayout.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import CompanyService from "@/services/company.service";

export default {
    name: "CompanyRegistration",
    components: {
        ContainerLayout,
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            email: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Email") })),
            // company_id: yup
            //     .string()
            //     .required(this.$t("Data is required!", { data: this.$t("Company") })),
            company_position: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Position") })),
            company_department: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Unit") })),
        });

        return {
            initialValues: {
                email: "",
                // company_id: "",
                company_position: "",
                company_department: "",
                file: null,
            },
            loading: false,
            companies: [],
            schema,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        CompanyService.getAll()
            .then((response) => {
                this.companies = response.data.data;
            })
            .catch(() => {
                this.companies = [];
            });
    },
    methods: {
        goBack() {
            this.navigateBackOrHome();
        },

        handleFileChange(event) {
            let file = event.target.files[0];
            if (file) {
                const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'application/pdf'];
                if (!validTypes.includes(file.type)) {
                    this.$vueAlert.alert(this.$t('Please upload an image or PDF file'), this.$t('Invalid file format'), 'error');
                    event.target.value = "";
                    return;
                }

                if (file.size > 5000000) {
                    this.$vueAlert.alert(this.$t('Please upload a file with a maximum size of 5MB'), this.$t('File size is too large'), 'error');
                    event.target.value = "";
                    return;
                }

                // const reader = new FileReader();
                // reader.onload = (e) => {
                //     this.filePreview = e.target.result;
                // };
                // reader.readAsDataURL(file);
            } else {
                // this.filePreview = null;
            }
        },

        handleRegister(submission) {
            this.loading = true;
            let loader = this.$loading.show();

            let submitter_id = { submitter_id: this.currentUser.id };
            submission = { ...submission, ...submitter_id };

            if (this.currentCompany) {
                let company_id = { company_id: this.currentCompany.id };
                submission = { ...submission, ...company_id };
            }

            CompanyService
                .addAccountSubmission(submission)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    if (response.data.status == 'success') {
                        this.$vueAlert.alert(response.data.message, null, 'success').then(() => {
                            if (this.$route.query.from == 'company-registration') {
                                this.$router.push('/');
                            } else {
                                this.navigateBackOrHome();
                            }
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },
    }
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
</style>
  